import { Input, message, Modal, InputNumber, Select, DatePicker } from "antd";
import { Form } from "antd";
import React from "react";
import { AuthContext } from "../../../context/auth-context/AuthContext";
import apiService from "../../../services/apiServices";
import dayjs from 'dayjs';

const ModalCrear = ({ createModalOpen, setCreateModalOpen, setRefreshTable }) => {
  const [form] = Form.useForm();
  const { handleRefreshToken } = React.useContext(AuthContext);

  const handleSubmit = async (data) => {
    const dataForSubmit = {
            ...data,
            subscriptionEndDate: data.subscriptionEndDate
              ? dayjs(data.subscriptionEndDate)
              : null,
    }
    try {
      const tokenVerified = await handleRefreshToken();
      const res = await apiService.createUser(dataForSubmit, tokenVerified);
      if (!res.ok && res.error) {
        message.error(res.error || "Error al crear el usuario");
        return false;
      }      
      setRefreshTable((prev) => !prev);
      return true;
    } catch (error) {
      console.error("%c ERROR EN HANDLE SUBMIT","color: red", error);
      message.error("Error al crear el usuario");
      return false;
    }
  };

  return (
    <>
      <Modal

        title="Crear Nuevo Usuario"
        open={createModalOpen}
        onCancel={() => {
          setCreateModalOpen(false);
          form.resetFields();
        }}
        onOk={() => {
          form
            .validateFields()
            .then(async (values) => {
              //console.log("Nuevo usuario:", values);
              const success = await handleSubmit(values);
              form.resetFields();
              setCreateModalOpen(false);
              if (success) {
                message.success("Usuario creado exitosamente");                
              }
            })
            .catch((info) => {
              message.error("Los datos cargados son incorrectos");

              console.log("Validate Failed:", info);
            });
        }}
        okText="Crear"
        cancelText="Cancelar"
        width={800}
      >
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            role: "ADMIN",
            subscription: "Free",
            subscriptionStatus: "Active",            
            plan: "starter",
            experienceLimit: 3,
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "16px",
            }}
          >
            <Form.Item
              name="firstName"
              label="Nombre"
              rules={[
                { required: true, message: "Por favor ingrese el nombre" },
                {
                  min: 2,
                  message: "El nombre debe tener al menos 2 caracteres",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="lastName"
              label="Apellido"
              rules={[
                { required: true, message: "Por favor ingrese el apellido" },
                {
                  min: 2,
                  message: "El apellido debe tener al menos 2 caracteres",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="username"
              label="Usuario"
              rules={[
                { required: true, message: "Por favor ingrese el usuario" },
                {
                  min: 2,
                  message: "El usuario debe tener al menos 2 caracteres",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="email"
              label="Correo"
              rules={[
                { required: true, message: "Por favor ingrese el correo" },
                {
                  type: "email",
                  message: "Por favor ingrese un correo electrónico válido",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="password"
              label="Contraseña"
              rules={[
                { required: true, message: "Por favor ingrese la contraseña" },
                {
                  min: 8,
                  message: "La contraseña debe tener al menos 8 caracteres",
                },
                {
                  pattern: /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.{8,})/,
                  message:
                    "La contraseña debe contener al menos una mayúscula y un símbolo (!@#$%^&*)",
                },
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item
              name="confirmPassword"
              label="Confirmar Contraseña"
              dependencies={['password']}
              rules={[
                { required: true, message: "Por favor confirme la contraseña" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('Las contraseñas no coinciden'));
                  },
                }),
                ]}
              >
                <Input.Password />
              </Form.Item>
              <Form.Item name="role" label="Rol" initialValue="ADMIN" rules={[{ required: true }]}>
                <select className="ant-input">
                <option value="USER">USER</option>
                <option value="ADMIN">ADMIN</option>
                <option value="SUPER_ADMIN">SUPER_ADMIN</option>
                </select>
              </Form.Item>
              
              <Form.Item name="subscription" label="Suscripción">
                <Select>
                <Select.Option value="free">Freemium</Select.Option>
                <Select.Option value="mensual">Mensual</Select.Option>
                <Select.Option value="anual">Anual</Select.Option>
                </Select>
              </Form.Item>

              <Form.Item name="subscriptionStatus" label="Estado Suscripción">
                <Select>
                <Select.Option value="active">Activo</Select.Option>
                <Select.Option value="pending">Pendiente</Select.Option>
                <Select.Option value="suspend">Suspendido</Select.Option>
                <Select.Option value="cancel">Cancelado</Select.Option>
                </Select>
              </Form.Item>


              <Form.Item name="subscriptionEndDate" label="Fecha Fin Suscripción">
                <DatePicker
                //format="DD/MM/YYYY"
                style={{ width: "100%", borderColor: "#4CAF50" }}
                />
              </Form.Item>

            <Form.Item name="plan" initialValue="starter" label="Plan">
              <Select>
                <Select.Option value="starter">Starter</Select.Option>
                <Select.Option value="professional">Professional</Select.Option>
                <Select.Option value="corporate">Corporate</Select.Option>
              </Select>
            </Form.Item>

            <Form.Item
              name="experienceLimit"
              label="Límite de Experiencia"
              rules={[
                // { required: true, message: "Por favor ingrese un valor" },
                {
                  type: "number",
                  min: 3,
                  max: 100,
                  message: "El valor debe estar entre 3 y 100",
                },
              ]}
            >
              <InputNumber />
              {/* <InputNumber min={3} max={100} style={{ width: '100%' }} /> */}
            </Form.Item>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default ModalCrear;

